export enum WarningMessages {
  REQUIRED_FIELDS_WARNING = 'Please fill the required fields',
  COMPANY_RESPONSE_MISSING_WARNING = 'The company have not submitted response',
  RFP_NOT_INITIATED_WARNING = 'The RFP has not been initiated yet',
}
